import axios from "axios";
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useForm, FormProvider, useWatch } from "react-hook-form";
import { common } from "../../utils";
import { API_URL } from "./../../utils/api-utils";
import { GetUser } from "../../utils/sessions";
import { styleTextLink } from "../../utils/style";
//Material
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { BoxTemplate1 } from "../../stories/Box";
import './styles.css';
//Component
import { BaseContainer } from "../../stories/base-container";
import { ReactTable } from "../../stories/react-table";
import { Modal } from "../../stories/modal";
import FormInput from "../../stories/hook-controls/input";
//Function
import {
  titleCase,
  setDataToFormHookV2,
  isEmptyStr,
} from "../../utils/common-function";
import { ToDateText, ToDateTimeText } from "../../utils/date";
import * as alertDialog from "../../utils/alert";
import { useSelectRowOpenModal } from "./../function-api/useSelectRowOpenModal.js";

// Context

function ODSInventory() {
  //Context
  const {
    isOpen: isOpenDetail,
    close: closeDetail,
    Data: dataDetail,
    handleClickRow: clickDetail,
  } = useSelectRowOpenModal();
  //State
  const [DataList, setDataList] = useState([]);
  const [DataRow, setDataRow] = useState({});

  const [openModal, setOpenModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  //---------------------------
  const Search = async () => {
    let res = await GetODSInventory();
    setDataList(res);
  };
  useEffect(() => {
    Search();
  }, []);

  //Function
  const ViewDetail = async (row) => {
    clickDetail(row);
  };
  const Edit = (row) => {
    onOpenEditModal();
    setDataRow(row);
  };
  const Delete = async (ID) => {
    let res = await alertDialog.ConfirmDelete();
    if (!res) return;
    let param = {
      FEED_ID: ID,
    };
    let api_res = await DeleteODSInventory(param);
    if (api_res) {
      Search();
      alertDialog.del_success();
    }
  };
  //Event
  const onOpenAddModal = () => {
    setOpenModal(true);
    setEditMode(false);
    setDataRow(null);
  };
  const onOpenEditModal = () => {
    setOpenModal(true);
    setEditMode(true);
  };
  const onCloseModal = () => {
    setOpenModal(false);
  };

  const tablecomponent = () => {
    return (
      <>
        <Box m={2} className="btnstyle">
          <Button variant="contained" onClick={onOpenAddModal}>
            New Feed
          </Button>
        </Box>
      </>
    );
  };
  return (
    <>
      <BaseContainer>
        {/* <Typography style={{ marginLeft: "5px" }}>ODS Inventory</Typography> */}
        <BoxTemplate1 height="80vh" title="ODS Inventory">
        <ReactTable
          keyField="FEED_ID"
          data={DataList}
          columns={getODSInventoryColumns(Edit, Delete, ViewDetail)}
          headcomponent={tablecomponent}
          exportCsv
          hover
        />
        </BoxTemplate1>
      </BaseContainer>
      <DataModal
        editmode={editMode ? 1 : 0}
        open={openModal}
        onClose={onCloseModal}
        search={Search}
        dataRow={DataRow}
      />
      <ModalFeedDetail
        open={isOpenDetail}
        onClose={closeDetail}
        data={dataDetail}
      />
    </>
  );
}

function DataModal(props) {
  const { onClose } = props;
  const { open, editmode } = props;
  const { dataRow, search = () => {}, ...otherprops } = props;
  const method = useForm();
  const { setValue, getValues, setError, clearErrors, errors } = method;

  //Effect
  useEffect(() => {
    if (!open) return;
    if (editmode) {
      let data = setDataToFormHookV2(dataRow);
      setTimeout(() =>
        data?.forEach(({ name, value }) => setValue(name, value))
      );
    }
  }, [dataRow, setValue, open, editmode]);

  const SaveDetail = async () => {
    clearErrors("FEED_NAME");
    clearErrors("SRC_NAME");

    if (isEmptyStr(getValues().SRC_NAME)) {
      setError("SRC_NAME", {
        type: "manual",
        message: "The SRC Name field is required",
      });
      return;
    }
    if (isEmptyStr(getValues().FEED_NAME)) {
      setError("FEED_NAME", {
        type: "manual",
        message: "The Feed Name field is required",
      });
      return;
    }

    var feed_name = dataRow?.FEED_NAME;
    if (feed_name !== getValues().FEED_NAME) {
      let res_dup = await CheckDulplicateODSInventory({
        FEED_NAME: getValues().FEED_NAME,
      });
      if (res_dup) {
        setError("FEED_NAME", {
          type: "manual",
          message: "Feed Name is Duplicate.",
        });
        return;
      }
    }

    let param = {
      FEED_ID: dataRow?.FEED_ID,
      FEED_NAME: getValues().FEED_NAME,
      SRC_NAME: getValues().SRC_NAME,
      OWNER: getValues().OWNER,
      EMAIL: getValues().EMAIL,
      MOBILE: getValues().MOBILE,
      PATH_SOURCE: getValues().PATH_SOURCE,
      FREQUENCY: getValues().FREQUENCY,
      SLA: getValues().SLA,
      INTERFACE: getValues().INTERFACE,
      HOST: getValues().HOST,
      USER_NAME: getValues().USER_NAME,
      PWS: getValues().PWS,
      SESSION_OWNER: GetUser(),
    };

    let res = await SaveODSInventory(param);
    if (res) {
      search();
      onClose();
      alertDialog.inform_success();
    }
  };

  return (
    <div>
      <Modal
        {...otherprops}
        maxWidth="md"
        onSave={SaveDetail}
        title={editmode ? "Edit Feed" : "Add Feed"}
      >
        <FormProvider {...method}>
          <div>
            <Grid container spacing={1}>
              <Grid item md={6} xs={12}>
                <Box m={1}>
                  <FormInput name="SRC_NAME" label={titleCase("SRC_NAME")} />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box m={1}>
                  <FormInput name="FEED_NAME" label={titleCase("FEED_NAME")} />
                </Box>
              </Grid>
              <Grid item md={12} xs={12}>
                <Box m={1}>
                  <FormInput name="OWNER" label={titleCase("OWNER")} />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box m={1}>
                  <FormInput name="EMAIL" label={titleCase("EMAIL")} />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box m={1}>
                  <FormInput name="MOBILE" label={titleCase("MOBILE")} />
                </Box>
              </Grid>
              <Grid item md={12} xs={12}>
                <Box m={1}>
                  <FormInput
                    name="PATH_SOURCE"
                    label={titleCase("PATH_SOURCE")}
                  />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box m={1}>
                  <FormInput name="FREQUENCY" label={titleCase("FREQUENCY")} />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box m={1}>
                  <FormInput
                    name="SLA"
                    label={titleCase("SLA")}
                  />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box m={1}>
                  <FormInput name="INTERFACE" label={titleCase("INTERFACE")} />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box m={1}>
                  <FormInput name="HOST" label={titleCase("HOST")} />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box m={1}>
                  <FormInput name="USER_NAME" label={titleCase("USER_NAME")} />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box m={1}>
                  <FormInput name="PWS" label={titleCase("PASSWORD")} />
                </Box>
              </Grid>
            </Grid>
          </div>
        </FormProvider>
      </Modal>
    </div>
  );
}

function ModalFeedDetail(props) {
  const [resultData, setData] = useState([]);
  const { open, onClose, data } = props;

  useEffect(() => {
    if (!open) return;
    (async () => {
      let res = await GetPlanDetailByFeedName({ FEED_NAME: data?.FEED_NAME });
      if (!res) {
        alertDialog.Inform("Data not found.");
        onClose();
      } else {
        setData(res);
      }
    })();
  }, [open, data, onClose]);

  const useStyles = makeStyles((theme) => ({
    heading: {
      fontSize: theme.typography.pxToRem(16),
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(16),
      color: theme.palette.text.secondary,
    },
  }));

  const classes = useStyles();
  const captionText = () => {
    return `Feed Detail`;
  };

  return (
    <>
      <Modal
        {...props}
        title={captionText()}
        hiddenSave
        maxWidth="md"
        className="headerModalPlanDetail"
      >
        <Box p={1} className="boxTableDetail">
          <Table className="tableDetail">
            <colgroup>
              <col style={{ width: "150px" }} />
              <col style={{ width: "auto" }} />
            </colgroup>
            <TableBody>
              <TableRow>
                <TableCell scope="row" className="tdHeaderRow">
                  <Typography className={classes.heading}>
                    {titleCase("Plan")}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography className={classes.secondaryHeading}>
                    : {resultData?.PLAN_TYPE_TEXT} - {resultData?.PLAN_ID} -{" "}
                    {resultData?.PLAN_NAME}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell scope="row" className="tdHeaderRow">
                  <Typography className={classes.heading}>
                    {titleCase("OWNER")}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography className={classes.secondaryHeading}>
                    : {resultData?.OWNER}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell scope="row" className="tdHeaderRow">
                  <Typography className={classes.heading}>
                    {titleCase("SCHEDULE")}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography className={classes.secondaryHeading}>
                    : {resultData?.SCHEDULE_TEXT}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell scope="row" className="tdHeaderRow">
                  <Typography className={classes.heading}>
                    {titleCase("VALIDATION_KEY")}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography className={classes.secondaryHeading}>
                    : {resultData?.VALIDATION_KEY}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell scope="row" className="tdHeaderRow">
                  <Typography className={classes.heading}>
                    {titleCase("Execution Status")}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography className={classes.secondaryHeading}>
                    :{" "}
                    {ToDateTimeText(resultData?.STATUS_DATETIME) +
                      ", " +
                      resultData?.EXECUTION_TYPE +
                      ", " +
                      resultData?.STATUS_TEXT}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell scope="row" className="tdHeaderRow">
                  <Typography className={classes.heading}>
                    {titleCase("TAGS")}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography className={classes.secondaryHeading}>
                    : {resultData?.TAGS || ""}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Modal>
    </>
  );
}

// Column
const getODSInventoryColumns = (
  editData,
  deleteData,
  viewDetail = () => {}
) => {
  const onClickCol = {
    onClick: async (e, column, columnIndex, row, rowIndex) => {
      viewDetail(row);
    },
  };
  const columns = [
    {
      dataField: "OP2",
      text: "",
      csvExport: false,
      headerStyle: () => {
        return { width: "5%" };
      },
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            <EditIcon
              color="action"
              onClick={() => {
                editData(row);
              }}
            />
            <DeleteIcon
              color="action"
              onClick={() => {
                deleteData(row.FEED_ID);
              }}
            />
          </Box>
        );
      },
    },
    {
      dataField: "SRC_NAME",
      text: titleCase("src_name"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "FEED_NAME",
      text: titleCase("feed_name"),
      style: styleTextLink,
      sort: true,
      headerStyle: () => {
      return { width: "10%" };
    }
    },
    {
      dataField: "OWNER",
      text: titleCase("Owner"),
      sort: true,
      headerStyle: () => {
      return { width: "10%" };
    }
    },
    {
      dataField: "EMAIL",
      text: "E-Mail",
      sort: true,
      headerStyle: () => {
      return { width: "10%" };
    }
    },
    {
      dataField: "MOBILE",
      text: "Mobile",
      sort: true,
      headerStyle: () => {
      return { width: "10%" };
    }
    },
    {
      dataField: "PATH_SOURCE",
      text: "Path source",
      sort: true,
      headerStyle: () => {
      return { width: "10%" };
    }
    },
    {
      dataField: "FREQUENCY",
      text: titleCase("Frequency"),
      sort: true,
      headerStyle: () => {
      return { width: "10%" };
    }
    },
    {
      dataField: "SLA",
      text: titleCase("SLA"),
      sort: true,
      headerStyle: () => {
      return { width: "10%" };
    }
    },
    {
      dataField: "INTERFACE",
      text: titleCase("Interface"),
      sort: true,
      headerStyle: () => {
      return { width: "10%" };
    }
    },
    {
      dataField: "HOST",
      text: titleCase("HOST"),
      sort: true,
      headerStyle: () => {
      return { width: "10%" };
    }
    },
    {
      dataField: "USER_NAME",
      text: titleCase("USER_NAME"),
      sort: true,
      headerStyle: () => {
      return { width: "10%" };
    }
    },
    {
      dataField: "PWS",
      text: titleCase("PASSWORD"),
      sort: true,
      headerStyle: () => {
      return { width: "10%" };
    }
    },
  ];
  var foundIndex = columns.findIndex((x) => x.dataField === "FEED_NAME");
  columns[foundIndex] = { ...columns[foundIndex], events: onClickCol };
  return columns;
};

// api
const GetODSInventory = async (param) => {
  let url = `${API_URL.Job}/api/Master/GetODSInventory`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

const SaveODSInventory = async (param) => {
  let url = `${API_URL.Job}/api/Master/SaveODSInventory`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

const DeleteODSInventory = async (param) => {
  let url = `${API_URL.Job}/api/Master/DeleteODSInventory`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

const CheckDulplicateODSInventory = async (param) => {
  let url = `${API_URL.Job}/api/Master/CheckDulplicateODSInventory`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
const GetPlanDetailByFeedName = async (param) => {
  let url = `${API_URL.Job}/api/Master/GetPlanDetailByFeedName`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
export default ODSInventory;
